import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "m11.375 19.833-.875 3.5L9.333 24.5h9.334L17.5 23.333l-.875-3.5M3.5 15.167h21M5.833 19.833h16.334A2.333 2.333 0 0 0 24.5 17.5V5.833A2.333 2.333 0 0 0 22.167 3.5H5.833A2.333 2.333 0 0 0 3.5 5.833V17.5a2.333 2.333 0 0 0 2.333 2.333z",
      stroke: "#000",
      "stroke-opacity": ".87",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }